export default "__VITE_ASSET__Mh76DXGs__"